var map = {
	"./alpine-icon.svg": "afd1",
	"./amex-icon.svg": "7432",
	"./centos-icon.svg": "f7e7",
	"./debian-icon.svg": "062f",
	"./desktop-icon.svg": "bfa1",
	"./discover-icon.svg": "241b",
	"./fedora-icon.svg": "acf0",
	"./mastercard-icon.svg": "6c5f",
	"./paypal-colored-icon.svg": "d78d",
	"./paypal-icon.svg": "209d",
	"./ubuntu-icon.svg": "1c7a",
	"./visa-icon.svg": "e238"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "085c";